<template>
  <path pid="0" d="M23 12h-3a1 1 0 000 2h2a9 9 0 01-8 8V9.87a4 4 0 10-2 0V22a9 9 0 01-7.95-8H6a1 1 0 000-2H3a1 1 0 00-1 1 11 11 0 0010.71 11H13a11 11 0 0011-11 1 1 0 00-1-1zM11 6a2 2 0 112 2 2 2 0 01-2-2z"/>
</template>
